import HotelSetupWizard from './HotelSetupWizard';

export default function HotelSetupWizardIndia(props) {
  return <HotelSetupWizard {...props} country="india" />;
}
